<div class="bottomSheetContainer" (click)="dimiss()">
  <div class="timeline-container">
    <div class="timeline-header">Seguimiento Jugada</div>
    @for (seguimiento of listaSeguimiento; track seguimiento) {
      <div class="timeline">
        <div class="timeline-item">
          <div class="timeline-item-content">
            <div>
              <div class="timestamp">{{seguimiento.fecha | date: 'dd/MM/yyyyY HH:mm'}}</div>
              <div class="status">{{seguimiento.nombre}}</div>
            </div>
            @if (seguimiento.url) {
              <div class="view-button" (click)="goToLink(seguimiento.url)">Ver</div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>